import { TOPBAR_HEIGHT } from '../topBar/styles';

export const card = {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.14)',   // fix 1 — was 0.12
    borderRadius: '22px',
    p: { xs: 2, md: 2.5 },
    scrollMarginTop: {
        xs: `${TOPBAR_HEIGHT.xs + 16}px`,
        md: `${TOPBAR_HEIGHT.md + 16}px`,
    },
};

export const header = {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: 1.5,
};

export const publisherInfo = {
    flex: 1,
    minWidth: 0,
};

export const publisherName = {
    fontWeight: 600,
    fontSize: '18px',                             // fix 2 — was 17px (1.0625rem)
    color: 'var(--ecal-white)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const metaRow = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 1,
    mt: '4px',                                    // fix 3 — was 6px (mt:0.75)
};

export const metaPill = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '3.2px 8.8px',                       // fix 3 — was 2px 6px
    borderRadius: '999px',
    fontSize: '0.72rem',
    fontWeight: 600,                              // fix 3 — was 500
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.12)',   // fix 3 — explicit border
    color: 'var(--ecal-white)',
};

export const metaText = {
    fontSize: '0.6875rem',
    color: 'var(--ecal-midgrey)',
    alignSelf: 'center',
};

export const unsubscribeWrapper = {
    background: 'linear-gradient(90deg, #00D7FF, #0078FF)',
    borderRadius: '999px',
    padding: '1.5px',
    display: 'inline-flex',
    flexShrink: 0,
};

export const unsubscribeButton = {
    borderRadius: '999px',
    px: '17.6px',                                 // fix 5 — was 0.9rem (~14.4px)
    py: '9.6px',                                  // fix 5 — was 0.4rem (~6.4px)
    border: 'none',
    background: 'var(--ecal-navy)',
    color: 'var(--ecal-white)',
    fontSize: '0.75rem',
    fontWeight: 600,
    '&:hover': { background: 'var(--ecal-navy)', border: 'none' },
};

export const schedulesGrid = {
    display: 'grid',
    gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
    gap: 2,
    mt: 2.5,
};

// Grid item (child of schedulesGrid) — overrides the default grid-item
// min-width:auto so this section shrinks to its track's actual size instead
// of being pushed wider by its own unshrunk content.
export const scheduleSection = {
    minWidth: 0,
};

export const schedulesLabel = {
    fontSize: '12px',                             // fix 4 — was 0.72rem (11.52px)
    textTransform: 'uppercase',
    letterSpacing: '0.6px',                       // fix 4 — was 0.9216px (0.08em)
    color: 'var(--ecal-lightgrey)',
    mb: 1,
};

export const scheduleItem = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    p: 1.25,
    borderRadius: '10px',
    border: '1px solid rgba(255,255,255,0.10)',
};

export const scheduleName = {
    fontSize: '0.875rem',
    color: 'var(--ecal-white)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const scheduleAction = {
    fontSize: '12px',                             // fix 7 — was 0.72rem (11.52px)
    color: 'var(--ecal-lightblue)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    flexShrink: 0,
    '&:hover': { textDecoration: 'underline' },
};

export const emptySchedules = {
    fontSize: '0.72rem',
    color: 'var(--ecal-midgrey)',
};

// Grows naturally up to 4 items (~184px), then scrolls
// Scrollbar hidden at rest, appears on hover
export const scheduleList = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    maxHeight: '184px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '4px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': { background: 'transparent', borderRadius: '4px' },
    '&:hover::-webkit-scrollbar-thumb': { background: 'rgba(187,188,188,0.25)' },
    '&:hover::-webkit-scrollbar-thumb:hover': { background: 'rgba(0,215,255,0.4)' },
};
